var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInDiscovery = function SvgInDiscovery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 94 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#223838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M47 16.56v60M17 46.56h60M25.784 25.344l42.432 42.432M68.216 25.344 25.784 67.776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED5321",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M47 16.56a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M47 91.56a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M9.5 54.06a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M84.5 54.06a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M20.486 27.546a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M73.514 80.574a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M73.514 27.546a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M20.486 80.574a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
  })));
};
export default SvgInDiscovery;